import * as z from "zod";

export const doesEbayIntegrationExist = {
  name: "doesEbayIntegrationExist" as const,
  // No input parameters needed - will use current team context
  input: z.object({}),

  // Output indicates whether the integration exists
  output: z.object({ exists: z.boolean() }),
};
